import React from 'react';
import './Table.css';
import { FiAlertCircle } from 'react-icons/fi';

const Table = ({ 
  data = [], 
  columns = [],
  isLoading = false,
  onSort,
  sortConfig = { key: null, direction: 'asc' }
}) => {
  const handleSort = (column) => {
    if (column.sortable && onSort) {
      onSort(column.key);
    }
  };

  if (isLoading) {
    return (
      <div className="table-section">
        <div className="table-container">
          <div className="loading-overlay">
            <div className="loading-spinner" />
          </div>
          <table>
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th key={index}>{column.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={columns.length}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className="table-section">
        <div className="table-container">
          <div className="empty-state">
            <FiAlertCircle className="empty-state-icon" />
            <p className="empty-state-text">Gösterilecek veri bulunamadı</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="table-section">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th 
                  key={index}
                  onClick={() => handleSort(column)}
                  className={`
                    ${column.sortable ? 'sortable' : ''} 
                    ${sortConfig.key === column.key ? `sort-${sortConfig.direction}` : ''}
                  `}
                >
                  {column.title}
                  {column.sortable && (
                    <span className="sort-icon" />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td key={`${rowIndex}-${colIndex}`}>
                    {column.render ? column.render(row[column.key], row) : (
                      column.type === 'status' ? (
                        <span className={`status status-${row[column.key].toLowerCase()}`}>
                          {row[column.key]}
                        </span>
                      ) : row[column.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table; 